export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_09.cc0797f2.jpg";